// Firebase's web config belongs in the app's code and none of it is secret: the API key only names
// the project, and access is up to Security Rules and IAM.
// https://firebase.google.com/docs/web/setup, https://firebase.google.com/docs/projects/api-keys
// This module stays free of window, so the service worker can import it too.

const staging = {
  gapiURL: 'https://gapi-rnotfbb3ta-ez.a.run.app/graphql',
  sentryDSN: 'https://c878a8a16b0b40888c12b0cbb06ff04e@o4504723873071104.ingest.us.sentry.io/4504723878248448',
  firebase: {
    apiKey: 'AIzaSyA92TpXdTEQJaKqHCrk3WcLnZgq6F5WbmU',
    authDomain: 'market-staging.web.app',
    databaseURL: 'https://nile-staging.firebaseio.com',
    projectId: 'nile-staging',
    storageBucket: 'nile-staging.appspot.com',
    messagingSenderId: '716613924917',
    appId: '1:716613924917:web:83b5ce142b32388e59597c',
    measurementId: 'G-56QK4S23DS',
  },
  qcStorageBucket: 'gs://nile-staging-qc-images',
  vapidKey: 'BMjxOqrIbabZLXmzso5zlSuWK4-xW6LxeQqDLzEjM6pd4pBq83_BVggGpljJScKJVb3l7U1tGWhbxOC5JJVaPUc',
};

const production: typeof staging = {
  gapiURL: 'https://gapi-2idh3vosoa-ez.a.run.app/graphql',
  sentryDSN: 'https://c878a8a16b0b40888c12b0cbb06ff04e@o4504723873071104.ingest.us.sentry.io/4504723878248448',
  firebase: {
    apiKey: 'AIzaSyCt7FnZ5YY1YqN9spEY1Sjl6V032xv-xbk',
    authDomain: 'market.nile.ag',
    databaseURL: 'https://nile-production.firebaseio.com',
    projectId: 'nile-production',
    storageBucket: 'nile-production.appspot.com',
    messagingSenderId: '721098944675',
    appId: '1:721098944675:web:43b502128d7beff0cc4f16',
    measurementId: 'G-79JF329RBP',
  },
  qcStorageBucket: 'gs://nile-production-qc-images',
  vapidKey: 'BF6YaZ0sYYKQlv_U5p0n9GULGKQ9VThy_sSLcgKrZxF1LpSoSEK8OTk41IAQ2_kxYutJ5s_dBFIvsMSBCdQaoi0',
};

// Local development runs against staging's Firebase project and a local gapi. A local .env can
// override any value, e.g. to point at another Firebase project; deployed builds ignore it.
const local = (): typeof staging => ({
  gapiURL: process.env.REACT_APP_GAPI_URL ?? 'http://localhost:9000/graphql',
  sentryDSN: process.env.REACT_APP_SENTRY_DSN ?? staging.sentryDSN,
  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? staging.firebase.apiKey,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? 'nile-staging.firebaseapp.com',
    databaseURL: process.env.REACT_APP_FIREBASE_DB_URL ?? staging.firebase.databaseURL,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? staging.firebase.projectId,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? staging.firebase.storageBucket,
    messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID ?? staging.firebase.messagingSenderId,
    appId: process.env.REACT_APP_FIREBASE_APP_ID ?? staging.firebase.appId,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? staging.firebase.measurementId,
  },
  qcStorageBucket: process.env.REACT_APP_FIREBASE_QC_STORAGE_BUCKET ?? staging.qcStorageBucket,
  vapidKey: process.env.REACT_APP_FIREBASE_VAPID_TOKEN ?? staging.vapidKey,
});

// Baked in by the build's --env flag. The dev server and bun test leave it unset, which is local.
export const environment = process.env.MARKET_ENV ?? 'local';

// Read process.env directly so the build can drop the other environments' config.
export const config =
  process.env.MARKET_ENV === 'production' ? production : process.env.MARKET_ENV === 'staging' ? staging : local();
